import { compose, mapProps, lifecycle, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { contains, reject } from 'ramda';
import {
  fetchShopsIfNotFetched,
  updateShopFilter,
  selectAll,
  deselectAll,
} from '../actions';
import {
  getShopFilters,
  getShopFilterAllChecked,
  getActiveShopIds,
} from '../selectors';

const ShopFilterContainer = compose(
  connect(
    state => ({
      filters: getShopFilters(state),
      allChecked: getShopFilterAllChecked(state),
      title: `Shop ${getShopFilterAllChecked(state) ? '(all)' : `(${getActiveShopIds(state).length})`}`,
    }),
    {
      updateShopFilter,
      fetchFilterData: fetchShopsIfNotFetched,
      selectAll,
      deselectAll,
    },
  ),
  withHandlers({
    updateFilter: props => (shop) => {
      if (shop === true) {
        return props.selectAll();
      }

      if (shop === false) {
        return props.deselectAll();
      }

      return props.updateShopFilter(shop);
    },
  }),
  mapProps(props => ({
    ...props,
    filters: reject(item => contains(item.title, props.removeFilters || []), props.filters),
  })),
  lifecycle({
    componentDidMount() {
      this.props.fetchFilterData();
    },
  })
);

export default ShopFilterContainer;
